var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Condition, CondTag } from "@easyquery/core";
import { lcv } from '../utils/lcv';
var ConditionEx = /** @class */ (function (_super) {
    __extends(ConditionEx, _super);
    function ConditionEx() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.readOnly = false;
        _this.parameterized = false;
        _this.inJoin = false;
        return _this;
    }
    ConditionEx.prototype.isReadOnly = function () {
        return this.readOnly || (this.getParent() && this.getParent().isReadOnly());
    };
    ConditionEx.prototype.setReadOnly = function (value) {
        this.readOnly = value || (this.getParent() && this.getParent().isReadOnly());
        this.conditions && this.conditions.forEach(function (cond) {
            cond.setReadOnly(value);
        });
    };
    ConditionEx.prototype.isParameterized = function () {
        return this.parameterized;
    };
    ConditionEx.prototype.setParameterized = function (value) {
        this.parameterized = value;
    };
    ConditionEx.prototype.isInJoin = function () {
        return this.inJoin;
    };
    ConditionEx.prototype.setInJoin = function (value) {
        this.inJoin = value;
    };
    ConditionEx.prototype.loadFromData = function (model, data) {
        _super.prototype.loadFromData.call(this, model, data);
        if (lcv.__kt <= 1)
            return;
        if (typeof data.readOnly !== 'undefined') {
            this.setReadOnly(data.readOnly);
        }
        if (typeof data.inJoin !== 'undefined') {
            this.setInJoin(data.inJoin);
        }
        if (typeof data.parameterized !== 'undefined') {
            this.setParameterized(data.parameterized);
        }
        //if condition group
        //this.linkType = data.linking;
        if (data.conds) {
            for (var i = 0; i < data.conds.length; i++) {
                var newCond = this.query.createCondition();
                newCond.loadFromData(model, data.conds[i]);
                this.conditions.push(newCond);
                newCond.setParent(this);
            }
        }
    };
    ConditionEx.prototype.saveToData = function () {
        var obj = _super.prototype.saveToData.call(this);
        if (lcv.__kt <= 1)
            return obj;
        if (this.isReadOnly()) {
            obj.readOnly = this.isReadOnly();
        }
        if (this.isParameterized()) {
            obj.parameterized = this.isParameterized();
        }
        if (this.isInJoin()) {
            obj.inJoin = this.isInJoin();
        }
        if (this.tag == CondTag.Group) {
            //if condition group
            //obj.linking = this.linkType;
            obj.conds = [];
            for (var i = 0; i < this.conditions.length; i++) {
                obj.conds.push(this.conditions[i].saveToData());
            }
        }
        return obj;
    };
    return ConditionEx;
}(Condition));
export { ConditionEx };
//# sourceMappingURL=condition_ex.js.map